import React, {Component} from 'react';

class CardFlippable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            size: this.props.size,
            isFlipped: false
        };

        this.toggleFlip = this.toggleFlip.bind(this);
    }

    toggleFlip(e) {
        e.preventDefault();
        this.setState({
            isFlipped: !this.state.isFlipped
        });
    }

    render() {
        return (
            <div className='col-md-4 my-2' key={this.state.size.id}>
                <div className={this.state.isFlipped ? 'card-flip flipped' : 'card-flip'}>
                    <div className='flip'>
                        <div className="front">
                            <div className="card rounded-0">
                                <div className={this.props.localState.size.id === this.state.size.id ? 'card-body card-grey text-center selected-item' : 'card-body card-grey text-center'}>
                                    <div className='d-flex flex-column justify-content-between' style={{minHeight: '210px'}}>
                                        <div>
                                            <h2 className="text-white pt-1" style={{marginBottom: '0'}}>
                                                {this.state.size.size_uk} {this.state.size.variation.type == 'man_and_van' ? (this.state.size.size_uk > 1 ? ' Cubic Yards' : ' Cubic Yard') : ''}
                                            </h2>
                                            <h3 className='pt-2' style={{color: '#FDB913'}}>&#163;{this.state.size.price / 100}</h3>
                                        </div>
                                        <div>
                                            <img src={`/assets/img/white/${this.state.size.image}`} width="250"
                                                 alt="icon"/>
                                        </div>
                                    </div>
                                    <div className="mt-2">
                                        <button className="btn btn-round py-3 btn-cw btn-yellow"
                                                onClick={(e) => this.props.handleSelectJunk(this.state.size)}>select
                                        </button>
                                    </div>
                                    <div className='pt-1'>
                                        <small><a href='#' className="text-white"
                                                  onClick={(e) => this.toggleFlip(e)}>more size info</a></small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="back">
                            <div className="card rounded-0">
                                <div className={this.props.localState.size.id === this.state.size.id ? 'card-body card-yellow text-center selected-item' : 'card-body card-yellow text-center'}>
                                    <div className='' style={{minHeight: '210px'}}>
                                        <div>
                                            <h2 className="text-white pt-1" style={{marginBottom: '0'}}>{this.state.size.size_uk} Cubic Yard{this.state.size.size_uk > 1 ? 's' : ''} </h2>
                                            <h3 className='pt-2' style={{color: '#514F4C'}}>&#163;{this.state.size.price / 100}</h3>
                                        </div>
                                        <div className='pt-4'>
                                            <div className='align-self-center'>
                                                <p className="text-white pt-2 pb-1">SAME SIZE AS</p>
                                                <p>
                                                    <small>{this.state.size.similar_to}</small>
                                                </p>
                                                <p className="pt-4 pb-1">
                                                    <small> Unsure? Send us a <span className='prohibited-items-alt' onClick={this.props.openModal}>photo</span>.</small>
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mt-2">
                                        <button className="btn btn-round py-3 btn-cw btn-white"
                                                onClick={(e) => this.props.handleSelectJunk(this.state.size)}>select
                                        </button>
                                    </div>
                                    <div className='pt-1'>
                                        <small><a href='#' className="text-white"
                                                  onClick={(e) => this.toggleFlip(e)}>less info</a></small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default CardFlippable;

